<div
  #dialog
  aria-describedby="flight-plus-hotel-modal-content"
  aria-labelledby="modalTitle"
  class="flight-plus-hotel-container text-center"
  role="dialog"
  tabindex="0"
>
  <div>
    <a
      (click)="setValue('cancel')"
      class="closeIcon"
      href="javascript:void(0)"
      role="button"
    >
      <span class="sr-only">close</span>
    </a>
  </div>
  <div>
    <img
      alt=""
      class="flightHotelIcon"
      src="{{ flightHotelContent?.overlayImage }}"
    />
  </div>
  <div class="modal-header pl-0 pr-0 pt-0 pb-0">
    <h2 class="mt-3 mb-3 w-100 head_text">
      {{ flightHotelContent?.name }}{{ destinationCity }}
    </h2>
  </div>
  <div id="flight-plus-hotel-modal-content">
    <p class="mt-3 mb-4 deatails_text">{{ flightHotelContent?.description }}</p>
    <div>
      <span class="d-lg-block d-sm-block search_head">
        {{ flightHotelContent?.descriptionOther }}
      </span>
      <span class="d-lg-block d-sm-block itin_text from_to_span">
        {{ destination }}
      </span>
      <span class="d-lg-block d-sm-block itin_text date_span">
        {{ travelDates }}
      </span>
      <span class="d-lg-block d-sm-block itin_text room_span">
        {{ passengers }}
      </span>
    </div>
    <div
      class="mt-4 mb-3 button_container justify-content-center d-flex flex-sm-column-reverse flex-md-row flex-lg-row"
    >
      <button
        (click)="setValue(flightOnlyButtonLabel)"
        *ngIf="flightHotelContent?.flightOnlyButtonLabel"
        class="btn-outline-secondary-cta button_cont mt-2 mr-3 pt-2 pb-2 pl-3 pr-3 text-center search_flights_button"
      >
        {{ flightHotelContent?.flightOnlyButtonLabel }}
      </button>
      <button
        (click)="setValue(externalLinkButtonLabel)"
        class="mt-2 pt-2 pb-2 pl-2 pr-2 text-center continue_travel_button"
      >
        {{ flightHotelContent?.externalLinkButtonLabel }}
        <span>
          <img
            class="arrow_head"
            src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
          />
        </span>
      </button>
    </div>
    <div>
      <p
        [innerHtml]="flightHotelContent?.disclaimer"
        class="disclaimer_cont pt-xl-4 pt-md-4 pt-lg-4"
      ></p>
    </div>
  </div>
</div>
